webpackJsonp([7],{

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page404',
  components: {},
  data: function data() {
    return {
      poster: __webpack_require__(498)
    };
  },

  methods: {
    goHome: function goHome() {
      this.$router.push('/');
    }
  }
});

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(497);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(169)("6f95fb1e", content, true, {});

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(168)(true);
// imports


// module
exports.push([module.i, ".vlt-404{height:100%}.sec-404{position:absolute;z-index:100;top:40%;left:12%}.sec-404 .errorimage{width:80%}.sec-404 p{font-family:HelveticaNeueMedium;color:#fff;font-size:30px;font-weight:500}.sec-404 .go-home{margin:50px 0 20px;line-height:39px;border:2px solid;text-align:center;font-weight:700;cursor:pointer}.sec-404 .oops{margin:15px 0;line-height:37px;text-align:start}@media only screen and (max-width:600px){.sec-404{top:30%}.sec-404 .errorimage{width:50%}.sec-404 p{font-size:10px}.sec-404 .go-home{margin:20px 0 10px}}@media only screen and (max-width:768px){.sec-404 .errorimage{width:50%}.sec-404 p{font-size:20px}}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/src/components/Page404/Page404.vue"],"names":[],"mappings":"AACA,SAAS,WAAW,CACnB,AACD,SAAS,kBAAkB,YAAY,QAAQ,QAAQ,CACtD,AACD,qBAAqB,SAAS,CAC7B,AACD,WAAW,gCAAkC,WAAc,eAAe,eAAe,CACxF,AACD,kBAAkB,mBAAqB,iBAAiB,iBAAiB,kBAAkB,gBAAiB,cAAc,CACzH,AACD,eAAe,cAAc,iBAAiB,gBAAgB,CAC7D,AACD,yCACA,SAAS,OAAO,CACf,AACD,qBAAqB,SAAS,CAC7B,AACD,WAAW,cAAc,CACxB,AACD,kBAAkB,kBAAoB,CACrC,CACA,AACD,yCACA,qBAAqB,SAAS,CAC7B,AACD,WAAW,cAAc,CACxB,CACA","file":"Page404.vue","sourcesContent":["\n.vlt-404{height:100%\n}\n.sec-404{position:absolute;z-index:100;top:40%;left:12%\n}\n.sec-404 .errorimage{width:80%\n}\n.sec-404 p{font-family:\"HelveticaNeueMedium\";color:#FFFFFF;font-size:30px;font-weight:500\n}\n.sec-404 .go-home{margin:50px 0 20px 0;line-height:39px;border:2px solid;text-align:center;font-weight:bold;cursor:pointer\n}\n.sec-404 .oops{margin:15px 0;line-height:37px;text-align:start\n}\n@media only screen and (max-width: 600px){\n.sec-404{top:30%\n}\n.sec-404 .errorimage{width:50%\n}\n.sec-404 p{font-size:10px\n}\n.sec-404 .go-home{margin:20px 0 10px 0\n}\n}\n@media only screen and (max-width: 768px){\n.sec-404 .errorimage{width:50%\n}\n.sec-404 p{font-size:20px\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/404.1c94039.png";

/***/ }),

/***/ 499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vlt-404"},[_c('img',{attrs:{"src":_vm.poster,"width":"100%","height":"100%;","alt":"poster"}}),_vm._v(" "),_c('div',{staticClass:"sec-404"},[_c('img',{staticClass:"errorimage",attrs:{"src":__webpack_require__(500),"alt":"404 image"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-2 col-md-1 col-sm-0"}),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-md-5 col-sm-5"},[_c('p',{staticClass:"go-home",on:{"click":_vm.goHome}},[_vm._v("GO HOME")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-3 col-sm-0"}),_vm._v(" "),_vm._m(0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('p',{staticClass:"oops"},[_vm._v("Oops! Sorry Page not found.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/404-number.fc02028.png";

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__ = __webpack_require__(346);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b0a3950_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__ = __webpack_require__(499);
function injectStyle (ssrContext) {
  __webpack_require__(496)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b0a3950_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/7.47b995424ad497e2f66d.js